export default __webpack_public_path__ + "static/media/warning-icon-2.7084788a.svg";